var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('MarketPlace',{attrs:{"title":"The best graded produce available at scale from local farmers."}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }